import FieldWrapper from '@features/ui-form/components/FieldWrapper';
import Input from '@features/ui-form/components/Input';
import { WrappedInputProps } from '@features/ui-form/types';
import { useTranslation } from 'next-i18next';

export const CosparIdInput = ({ value, onChange, hideError = false, required = false, ...rest }: WrappedInputProps) => {
  const { t } = useTranslation('common');

  return (
    <FieldWrapper name="cosparId" label={t('spaceObject.cosparId')} hideError={hideError} required={required}>
      <Input placeholder={t('spaceObject.cosparId.placeholder')} value={value} onChange={onChange} {...rest} />
    </FieldWrapper>
  );
};
